<template>
    <section>
        <form v-if="success == false" @submit="reset_password" id="login" class="form-login" method="post" action="/auth/reset-password/">
            <div class="form-wrapper">
                <div class="form-group mb-4">
                    <svg viewBox="0 0 512 512"><path d="M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z"/></svg>
                    <input v-bind:class="{error: error}" v-model="email" type="email" placeholder="Email" class="form-control icon" required />
                </div>
                <p v-if="success == false" class="text-center mb-4"><i>{{ message }}</i></p>
                <button type="submit" class="btn btn-lg btn-primary center" v-bind:class="{load: loading}">
                    Reset Password
                    <div class="loading"></div>
                </button>
                <div class="mt-3 d-flex flex-column align-items-center text-center login-links">
                    <router-link :to="{name: 'login'}">
                        <small class="d-flex align-items-center"><svg viewBox="0 0 512 512" class="back-arrow mr-1"><path d="m217.9 256 127.1-127c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0l-144 143.9c-9.1 9.1-9.3 23.7-.7 33.1l144.6 144.9c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9z"/></svg> Back to Login</small>
                    </router-link>
                </div>
            </div>
        </form>
        <p v-if="success" class="text-center"><i>{{ message }}</i></p>
        <div v-if="success" class="mt-3 d-flex flex-column align-items-center text-center login-links">
            <router-link :to="{name: 'login'}">
                <small class="d-flex align-items-center"><svg viewBox="0 0 512 512" class="back-arrow mr-1"><path d="m217.9 256 127.1-127c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0l-144 143.9c-9.1 9.1-9.3 23.7-.7 33.1l144.6 144.9c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9z"/></svg> Back to Login</small>
            </router-link>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AuthResetPassword',
    metaInfo: {
        title: 'Reset password'
    },
    data () {
        return {
            email: null,
            success: false,
            message: null,
            error: false,
            loading: false
        }
    },
    methods: {
        reset_password: function (e) {
            e.preventDefault();
            this.loading = true;
            axios.post(process.env.VUE_APP_API_URL + '/api/user/reset-password', {
                email: this.email
            })
            .then(response => (
                this.loading = false,
                this.success = response.data['success'],
                this.message = response.data['message']
            ))
            .catch(error => (
                this.loading = false,
                this.error = true
            ))
        }
    }
}
</script>